import React, { useContext } from "react";

import { Typography } from "antd";
import { AppContext } from "App";

const HeroCall: React.FC = () => {
    const { maxWidth } = useContext(AppContext);

    return (
        <div className="hero-call__container"
            style={{ maxWidth: maxWidth }}
        >
            <div className="hero-call__wrapper">
                <Typography
                    className="hero-call__title"
                >
                    Affordable Tax Submission
                </Typography>
                <Typography
                    className="hero-call__description"
                >
                    We offer flexible payment plans to suit your needs. Only pay when you file your return, no upfront costs.
                </Typography>
            </div>
        </div>
    );
};

export default HeroCall;
